export const TRIGGER_ICON_SIZE_PX = 38;

export const ONBOARDING_AGENT_TOOLTIP_OPEN_DELAY_MS = 150;

/** Pointer travel, in pixels, before a press turns into a drag instead of a click. */
export const ONBOARDING_AGENT_DRAG_ACTIVATION_DISTANCE_PX = 5;

export const ONBOARDING_AGENT_TRIGGER_BOUNCE_INTERVAL_MS = 10 * 60 * 1000;
/** Duration of a single bounce cycle — matches the squash-and-stretch keyframe timing (see styles.ts). */
export const ONBOARDING_AGENT_TRIGGER_BOUNCE_DURATION_MS = 1400;
